import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import type { AppDispatch, RootState } from '../redux/store';
import Sidebar from './Sidebar';
import NavbarApp from './navbarApp';
// import { fetchUserTokens, fetchUserTransactions } from '../redux/thunks/tokenThunks'; // You need to create these thunks

const Token: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const authState = useSelector((state: RootState) => state.auth);
//   const tokenState = useSelector((state: RootState) => state.tokens); // add tokens reducer
//   const transactionState = useSelector((state: RootState) => state.transactions); // add transactions reducer

  const user = authState.user;
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    if (user?.id) {
    //   dispatch(fetchUserTokens(user.id));
    //   dispatch(fetchUserTransactions(user.id));
    }
  }, [user?.id]);

  return (
    <div className="min-h-screen text-white bg-black flex flex-col">
      <NavbarApp user={user} setSidebarOpen={setSidebarOpen}/>

      {/* Mobile Sidebar overlay */}
      <div
        className={`fixed inset-0 z-40 md:hidden transition-transform duration-300 ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div
          className="absolute inset-0 bg-black bg-opacity-50"
          onClick={() => setSidebarOpen(false)}
        />
        <div className="relative w-64 bg-gray-900 h-full">
          <Sidebar />
        </div>
      </div>

      {/* Content */}
      <div className="flex flex-1">
        <div className="hidden md:block w-64 bg-gray-900">
          <Sidebar />
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          <h1 className="text-2xl font-bold mb-4">My Tokens</h1>
          <div className="mb-8 p-4 bg-gray-800 rounded-lg">
            <p className="text-lg">
              <span className="font-semibold">Total Tokens:</span>{' '}
              {authState.loading ? 'Loading...' : user?.heartfeltToken || 0}
            </p>
          </div>

          <h2 className="text-xl font-semibold mb-2">Transaction History</h2>
          <div className="bg-gray-800 rounded-lg p-4">
            {/* {transactionState.loading ? (
              <p>Loading transactions...</p>
            ) : transactionState.transactions?.length ? (
              <ul>
                {transactionState.transactions.map((txn: any, index: number) => (
                  <li
                    key={index}
                    className="border-b border-gray-700 py-2 text-sm"
                  >
                    <div className="flex justify-between">
                      <span>{txn.description}</span>
                      <span
                        className={`${
                          txn.amount > 0 ? 'text-green-400' : 'text-red-400'
                        }`}
                      >
                        {txn.amount > 0 ? `+${txn.amount}` : txn.amount} Tokens
                      </span>
                    </div>
                    <p className="text-xs text-gray-400">{txn.date}</p>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No transactions found.</p>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Token;
